module.exports = __webpack_public_path__ + "static/media/sidenav-lavulogo.7a56de38.svg";